import { Ikon, type IkonNamn } from "../Ikon";
import { Kretslopp } from "./Kretslopp";
import { Shead } from "./Sektion";

const PUNKTER: [IkonNamn, string, string][] = [
  ["ledger", "Förslag med stöd i historiken", "Varje förslag visar hur många bokningar som stöder det och hur många som avviker."],
  ["sign", "Ni bestämmer", "Godkänn, ändra, avvisa eller skjut upp. Regler med starkt stöd, minst tio bokningar som alla är lika, kan godkännas flera åt gången."],
  ["log", "Gäller från det datum ni väljer", "Fakturor med tidigare datum konteras som förut, och varje beslut går att ångra."],
];

export function Inlarning() {
  return (
    <section className="s alt" id="inlarning">
      <div className="wrap">
        <Shead eyebrow="Inlärning" rubrik="Lär sig av er bokföring. Ekonomen godkänner varje regel." />
        <div className="sec">
          <div className="sitems">
            <p className="lead">Läs in en SIE-fil från affärssystemet. Agenten ser hur leverantörsfakturorna faktiskt har bokförts och föreslår konteringsregler. Inlärningen kräver ingen integration.</p>
            {PUNKTER.map(([ikon, h, p]) => (
              <div key={h} className="sitem"><span className="ico"><Ikon namn={ikon} /></span><div><h3>{h}</h3><p>{p}</p></div></div>
            ))}
          </div>
          <Kretslopp />
        </div>
      </div>
    </section>
  );
}
